<img class="studio_cards_images" *ngIf="src" [src]="src"/>
<span *ngIf="!src" #loadSvgImage></span>